"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const callbackTypes = require("./CallbackTypes");
// Message Types are exported this way to remain compatible with older client versions.
var Messages;
(function (Messages) {
    Messages.BpmnEvents = atlas_engine_sdk_1.Messages.BpmnEvents;
    Messages.SystemEvents = atlas_engine_sdk_1.Messages.SystemEvents;
    Messages.CallbackTypes = callbackTypes;
    Messages.EventAggregatorSettings = atlas_engine_sdk_1.Messages.EventAggregatorSettings;
})(Messages = exports.Messages || (exports.Messages = {}));
__exportStar(require("./IExternalTaskWorker"), exports);
__exportStar(require("./RestSettings"), exports);
__exportStar(require("./SocketSettings"), exports);
//# sourceMappingURL=index.js.map